export default "__VITE_ASSET__951f7a07__"